var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBlock)?_c('pre',{class:{ 'zi-bash': _vm.bash, 'zi-pre': _vm.bash || _vm.block }},[_c('code',[_vm._t("default")],2)]):_c('code',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }